module.exports = __webpack_public_path__ + "img/loading.7dd2dd1c.gif";